import { Modal, Button } from "antd"
import { CloseCircleOutlined } from "@ant-design/icons"
import { ScheduledEvent } from "../../scheduleApi"

type Props = {
  open: boolean
  onClose: () => void
  onConfirm: () => void
  event: ScheduledEvent | null
}

const RemoveScheduledEventModal = ({ open, onClose, onConfirm, event }: Props) => {
  return (
    <Modal
      open={open}
      onCancel={onClose}
      title={
        <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
          <CloseCircleOutlined style={{ color: '#ff4d4f', fontSize: '20px' }} />
          <span style={{ fontSize: '18px', fontWeight: '600' }}>Remove Event?</span>
        </div>
      }
      footer={
        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '12px' }}>
          <Button
            onClick={onClose}
          >
            Cancel
          </Button>
          <Button
            type="primary"  
            onClick={onConfirm}
          >
            Remove
          </Button>
        </div>
      }
      width={600}
      centered
      styles={{
        content: {
          borderRadius: '16px'
        }
      }}
    >
      <div style={{ 
        fontSize: '16px', 
        color: '#595959', 
        lineHeight: '1.5',
        padding: '16px 0'
      }}>
        Are you sure you want to remove <strong>{event?.jobName}</strong>? This action cannot be undone.
      </div>
    </Modal>
  )
}

export default RemoveScheduledEventModal